import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import AnimatedSection from '../../components/base/AnimatedSection';

const team = [
  {
    name: 'Dr. Sarah Mitchell',
    role: 'Editor-in-Chief',
    bio: 'AI researcher with 15+ years in machine learning.',
    image: 'https://public.readdy.ai/ai/img_res/2431fc6af913da35aa5af4563feffcdb.jpg',
  },
  {
    name: 'Marcus Chen',
    role: 'Blockchain Lead',
    bio: 'Former fintech executive and DeFi expert.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20asian%20man%20tech%20professional%20with%20friendly%20expression%20wearing%20smart%20casual%20attire%20soft%20studio%20lighting%20clean%20minimal%20background%20high%20quality%20corporate%20photography&width=300&height=300&seq=team-marcus-001&orientation=squarish',
  },
  {
    name: 'Dr. Emily Zhang',
    role: 'Quantum Editor',
    bio: 'PhD in quantum physics from MIT.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20young%20asian%20woman%20scientist%20researcher%20with%20confident%20smile%20wearing%20professional%20attire%20soft%20studio%20lighting%20clean%20minimal%20background%20high%20quality%20corporate%20photography&width=300&height=300&seq=team-emily-001&orientation=squarish',
  },
  {
    name: 'James Rodriguez',
    role: 'Security Analyst',
    bio: 'Cybersecurity consultant for Fortune 500.',
    image: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20hispanic%20man%20cybersecurity%20expert%20with%20serious%20professional%20expression%20wearing%20business%20casual%20soft%20studio%20lighting%20clean%20minimal%20background%20high%20quality%20corporate%20photography&width=300&height=300&seq=team-james-001&orientation=squarish',
  },
];

const values = [
  {
    icon: 'ri-lightbulb-line',
    title: 'Innovation First',
    description: 'We stay ahead of the curve, bringing you the latest breakthroughs.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Trusted Accuracy',
    description: 'Every article is fact-checked and reviewed by industry experts.',
  },
  {
    icon: 'ri-community-line',
    title: 'Community Driven',
    description: 'Built by tech enthusiasts, for tech enthusiasts worldwide.',
  },
];

export default function AboutPage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative pt-20">
        <div className="absolute inset-0 z-0 h-96">
          <img 
            src="https://static.readdy.ai/image/53ca90857eb8b592293a44cb2cc689ab/4ebf7f7e26050076570e21c6932fd707.jpeg"
            alt="About Background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 pt-20 pb-28">
          <div className="max-w-3xl mx-auto text-center">
            <div className={`inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-md rounded-full text-white mb-6 border border-cyan-400/30 transition-all duration-700 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <i className="ri-team-line text-cyan-400"></i>
              <span className="text-sm font-medium">Our Story</span>
            </div>
            <h1 className={`text-5xl font-extrabold text-white leading-tight mb-6 transition-all duration-700 delay-100 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              Shinva Medical Intruments Ltd
            </h1>
            <p className={`text-xl text-white/90 leading-relaxed transition-all duration-700 delay-200 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              Desde 1943 ahora en Argentina
            </p>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="relative z-20 -mt-12">
        <div className="max-w-5xl mx-auto px-6">
          <AnimatedSection animation="scale">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-6 border border-slate-100">
              {[
                { value: '3.2M+', label: 'Active Readers' },
                { value: '1,850+', label: 'Published Articles' },
                { value: '75+', label: 'Tech Experts' },
                { value: '98%', label: 'Satisfaction Rate' },
              ].map((stat, index) => (
                <div key={stat.label} className={`text-center p-4 ${index > 0 ? 'border-l border-slate-100' : ''}`}>
                  <div className="text-4xl font-bold bg-gradient-to-r from-cyan-500 to-teal-500 bg-clip-text text-transparent mb-1">{stat.value}</div>
                  <div className="text-sm text-gray-500 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Mission Section */}
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <AnimatedSection animation="fadeRight">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-50 rounded-full text-cyan-600 mb-6 border border-cyan-100">
                <i className="ri-focus-3-line"></i>
                <span className="text-sm font-medium">Our Mission</span>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6 leading-tight">
                Bridging Technology <br />& Understanding
              </h2>
              <p className="text-gray-600 leading-relaxed mb-5 text-lg">
                TechInsight was founded with a simple goal: to bridge the gap between cutting-edge technology and everyday understanding. We believe that knowledge should be accessible to everyone.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                Our team of expert writers and researchers work tirelessly to bring you the most accurate, insightful, and engaging content on emerging technologies that are shaping our future.
              </p>
              
              {/* Values */}
              <div className="space-y-4">
                {values.map((value, index) => (
                  <AnimatedSection key={value.title} animation="fadeRight" delay={index * 100}>
                    <div className="flex items-start gap-4 p-4 bg-slate-50 rounded-xl border border-slate-100 hover:shadow-lg hover:shadow-cyan-500/10 transition-all duration-500 hover:-translate-y-1">
                      <div className="w-10 h-10 rounded-lg bg-gradient-to-r from-cyan-500 to-teal-500 flex items-center justify-center flex-shrink-0">
                        <i className={`${value.icon} text-white text-lg`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900 mb-1">{value.title}</h4>
                        <p className="text-sm text-gray-600">{value.description}</p>
                      </div>
                    </div>
                  </AnimatedSection>
                ))}
              </div>
            </div>
          </AnimatedSection>
          <AnimatedSection animation="fadeLeft" delay={200}>
            <div className="relative">
              <div className="w-full h-[500px] rounded-2xl overflow-hidden shadow-2xl shadow-cyan-500/10 hover:shadow-cyan-500/20 transition-shadow duration-500">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20tech%20workspace%20with%20multiple%20screens%20showing%20data%20visualizations%20code%20editors%20and%20analytics%20dashboards%20warm%20ambient%20lighting%20plants%20and%20minimalist%20decor%20creative%20professional%20environment%20with%20cyan%20accent%20lighting&width=600&height=500&seq=about-mission-001&orientation=portrait"
                  alt="Our Workspace"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -left-6 w-48 h-48 rounded-xl overflow-hidden shadow-xl border-4 border-white animate-float">
                <img
                  src="https://readdy.ai/api/search-image?query=team%20meeting%20discussion%20around%20modern%20conference%20table%20with%20laptops%20tablets%20collaborative%20brainstorming%20session%20warm%20lighting%20professional%20tech%20office%20environment&width=200&height=200&seq=about-meeting-001&orientation=squarish"
                  alt="Team Meeting"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>

      {/* Team Section */}
      <div className="bg-gradient-to-b from-slate-50 to-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <AnimatedSection animation="fadeUp" className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-50 rounded-full text-cyan-600 mb-6 border border-cyan-100">
              <i className="ri-group-line"></i>
              <span className="text-sm font-medium">Leadership</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Industry experts and thought leaders driving innovation in tech journalism.
            </p>
          </AnimatedSection>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {team.map((member, index) => (
              <AnimatedSection key={member.name} animation="fadeUp" delay={index * 100} className="h-full">
                <div className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-xl hover:shadow-cyan-500/10 transition-all duration-500 hover:-translate-y-2 h-full flex flex-col">
                  <div className="w-full h-56 overflow-hidden flex-shrink-0">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-6 text-center flex flex-col flex-1 justify-between">
                    <div>
                      <h3 className="font-semibold text-gray-900 text-lg mb-1">{member.name}</h3>
                      <p className="text-cyan-600 text-sm font-medium mb-3">{member.role}</p>
                      <p className="text-gray-500 text-sm">{member.bio}</p>
                    </div>
                    <div className="flex items-center justify-center gap-3 mt-4">
                      <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-100 text-gray-500 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white transition-all cursor-pointer hover:scale-110">
                        <i className="ri-twitter-x-line text-sm"></i>
                      </a>
                      <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-100 text-gray-500 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-teal-500 hover:text-white transition-all cursor-pointer hover:scale-110">
                        <i className="ri-linkedin-fill text-sm"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <AnimatedSection animation="fade">
        <div className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img 
              src="https://readdy.ai/api/search-image?query=abstract%20technology%20network%20visualization%20with%20glowing%20nodes%20interconnected%20pathways%20flowing%20data%20streams%20in%20cyan%20and%20teal%20colors%20against%20dark%20gradient%20background%20with%20particle%20effects%20and%20volumetric%20lighting&width=1920&height=400&seq=about-cta-001&orientation=landscape"
              alt="CTA Background"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/70"></div>
          </div>
          
          <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-4xl font-bold text-white mb-4">Join Our Community</h2>
            <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto">
              Stay updated with the latest tech insights delivered directly to your inbox. Join 3.2M+ readers today.
            </p>
            <Link
              to="/get-started"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-cyan-500 to-teal-500 text-white rounded-lg hover:from-cyan-600 hover:to-teal-600 transition-all cursor-pointer font-semibold shadow-xl shadow-cyan-500/40 whitespace-nowrap hover:scale-105"
            >
              Get Started <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </AnimatedSection>

      <Footer />
    </div>
  );
}
